import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState   from 'vuex-persistedstate'
Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    imgSrc: '/static/img/public/headerimg-default.png',//header个人头像
    userName:"",//用户名称
    showName:"",
    token:"",//token值
    showSoftDetail:'',
    messageNum:'',//header消息数
    usertype:'',//判断企业号还是个人账号
    currentIndex:null,//首页当前页
    regType:"",//企业号的类别
    hflist:[] //存放有害因素列表
  },
  getters: {
    getimgSrc: state => state.imgSrc,
    getuserName: state => state.userName,
    getshowName: state => state.showName,
    gettoken: state => state.token,
    getshowSoftDetail: state => state.showSoftDetail,
    getmessageNum: state => state.messageNum,
    getusertype: state => state.usertype,
    getregType: state => state.regType,
    getcurrentIndex: state => state.currentIndex,
    gethflist: state => state.hflist,   //获取有害因素
  },
  mutations: {
    setimgSrc(state, data) {
      console.log(state,"state")
      state.imgSrc = data;
    },
    setuserName(state,data) {
      state.userName =data
    },
    setshowName(state,data) {
      state.showName =data
    },
    settoken(state,data) {
      state.token =data
    },
    setshowSoftDetail(state,data) {
      state.showSoftDetail =data
    },
    setmessageNum(state,data) {
      state.messageNum =data
    },
    setusertype(state,data) {
      state.usertype =data
    },
    setregType(state,data) {
      state.regType =data
    },
    setcurrentIndex(state,data) {
      state.currentIndex =data
    },
    sethflist(state,data) {   //改变有害因素
      state.hflist = data
    },
  },
  actions: {
  },
  plugins: [createPersistedState()]
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js